const heading6 = [
  "M4.35 10.73V8.47H6.8v2.26h1.03V5.27H6.8v2.24H4.35V5.27H3.32v5.46zm6.43.1A1.85 1.85 0 0 0 12.68 9a1.69 1.69 0 0 0-1.75-1.78c-.36 0-.71.12-1 .34v-.25c0-.22 0-.4.07-.6.15-.35.51-.59.9-.59.25 0 .5.1.68.3l.73-.75a1.96 1.96 0 0 0-1.4-.5c-.59 0-1.16.16-1.57.65-.38.44-.46.9-.46 1.5v1.34c0 .67.09 1.18.58 1.65a1.82 1.82 0 0 0 1.32.5zm0-.98A.84.84 0 0 1 9.93 9a.86.86 0 0 1 .86-.84.86.86 0 0 1 .85.86c0 .22-.1.44-.26.6a.82.82 0 0 1-.6.24z"
];
export {
  heading6
};
//# sourceMappingURL=heading6.js.map
